import type { FaireProductEntity } from "../../entity_types/product";

export const p_u2wnn88pbx: FaireProductEntity = {
  token: "p_u2wnn88pbx",
  type: "product",
  name: "Green Stripe Thank You Card",
  brandToken: "b_xzekcvz2yt",
  brandName: "Bon Femmes",
  imageUrl:
    "https://cdn.faire.com/fastly/3a9f91ded2ec149873cfb074c1e9e175b8ea2468ca71ced38d43f087d33db62a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36e78504458b59f203bd16107ae0570fdabe64aeff8f757234daca38926c751c.png",
  ],
  priceDollars: 3,
  description:
    "• A2\n• 4.25 x 5.5\"\n• Blank inside\n• Includes envelope\n• Printed on 100# cover smooth uncoated\n• Printed in Chicago, IL\n\nBrighten someone's day with Bon Femmes' adorable greeting card, designed in the heart of Chicago. Measuring 4.25\" x 5.5\" and printed on smooth, uncoated 100# cover paper, this card is blank inside for your heartfelt message. Each card has a matching envelope, making it perfect for any occasion. Crafted with love and printed locally, it's a charming way to share your thoughts.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:08.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
